import React, { useEffect, useState } from "react";
import { UserDetailsProps } from "./types";
import { Tab } from "@material-ui/core";
import useStyles from "./styles";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../store";
import { UserStoreStatisticsState } from "../../../../store/statistics/usersbystore/types";
import { thunkFetchUserStatisticsForStore } from "../../../../store/statistics/usersbystore/actions";
import UserDetailsTable from "../UserDetailsTable";

const UserDetails = ({
  periodFrom,
  periodTo,
  storeId,
  ageFrom,
  ageTo
}: UserDetailsProps) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const [selectedTab, setSelectedTab] = useState("1");

  const statisticsState = useSelector<AppState, UserStoreStatisticsState>(
    s => s.userStoreStatistics
  );
  let { userStoreStatistics, isLoading } = statisticsState;

  useEffect(() => {
    if (periodFrom && periodTo && storeId && ageTo) {
      dispatch(
        thunkFetchUserStatisticsForStore(
          periodFrom,
          periodTo,
          storeId,
          ageFrom,
          ageTo
        )
      );
    }
  }, [periodFrom, periodTo, storeId, ageTo]);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: string) => {
    setSelectedTab(newValue);
  };

  const populateDetailsGroupByParam = (groupBy: string) => {
    const byGroup = userStoreStatistics.reduce((acc: any, curr: any) => {
      let prop = curr[groupBy];
      if (!acc[prop]) {
        acc[prop] = {
          sales: 0,
          salesWomen: 0,
          salesMen: 0,
          quantity: 0,
          quantityMen: 0,
          quantityWomen: 0
        };
      }
      acc[prop].sales += curr.sales;
      acc[prop].salesMen += curr.gender === 1 ? curr.sales : 0;
      acc[prop].salesWomen += curr.gender === 0 ? curr.sales : 0;
      acc[prop].quantity += curr.quantity;
      acc[prop].quantityMen += curr.gender === 1 ? curr.quantity : 0;
      acc[prop].quantityWomen += curr.gender === 0 ? curr.quantity : 0;
      return acc;
    }, {});

    return Object.keys(byGroup).map(k => ({
      name: k,
      sales: byGroup[k].sales,
      salesMen: byGroup[k].salesMen,
      salesWomen: byGroup[k].salesWomen,
      quantity: byGroup[k].quantity,
      quantityMen: byGroup[k].quantityMen,
      quantityWomen: byGroup[k].quantityWomen
    }));
  };

  return (
    <TabContext value={selectedTab}>
      <TabList
        onChange={handleChange}
        className={classes.tabHeader}
        TabIndicatorProps={{ className: classes.indicator }}
      >
        <Tab
          label={"User sales by product category"}
          value="1"
          className={classes.tabEntry}
        />
        <Tab
          label={"User sales by product"}
          value="2"
          className={classes.tabEntry}
        />
      </TabList>

      <TabPanel value="1" className={classes.tabPanel}>
        <UserDetailsTable
          displayGraphSwitch={true}
          title={"Category"}
          isLoading={isLoading}
          users={populateDetailsGroupByParam("category")}
        />
      </TabPanel>
      <TabPanel value="2" className={classes.tabPanel}>
        <UserDetailsTable
          displayGraphSwitch={false}
          title={"Product"}
          isLoading={isLoading}
          users={populateDetailsGroupByParam("product")}
        />
      </TabPanel>
    </TabContext>
  );
};
export default UserDetails;
